import { apiClient } from './client'

export interface AuthUser {
  id: number
  name: string
  email: string
  role: string
  is_active: number
  email_verified: boolean
  created_at: string | null
}

export interface LoginResponse {
  token: string
  user: AuthUser
}

export async function registerUser(name: string, email: string, password: string) {
  const response = await apiClient.post('/api/auth/register', {
    name,
    email,
    password,
  })
  return response.data
}

export async function loginUser(email: string, password: string): Promise<LoginResponse> {
  const response = await apiClient.post('/api/auth/login', {
    email,
    password,
  })
  return response.data as LoginResponse
}

export async function fetchCurrentUser(): Promise<{ user: AuthUser }> {
  const response = await apiClient.get('/api/auth/me')
  return response.data as { user: AuthUser }
}

export async function logoutUser() {
  try {
    await apiClient.post('/api/auth/logout')
  } catch (err) {
    console.error('Logout request failed', err)
  }
}


